import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";

const initialState = {
  isLoading: false,
  fetchLoading: false,
  rides: {
    data: [],
    meta: {
      total: 0,
    },
  },
  singleRide: null,
};

// TODO: extra reducers
export const fetchRides = createAsyncThunk(
  "fetchRides/rides",
  async ({ enqueueSnackbar, limit = 10, page = 0, status }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`trips`, {
        params: {
          status,
          page: page + 1,
          limit,
        },
      });

      return {
        data: response.data.data.items,
        meta: {
          total: response.data.data.meta.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const fetchRidesContinuously = createAsyncThunk(
  "fetchRidesContinuously/rides",
  async ({ enqueueSnackbar, limit = 10, page = 0, status }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`trips`, {
        params: {
          status,
          page: page + 1,
          limit,
        },
      });

      return {
        data: response.data.data.items,
        meta: {
          total: response.data.data.meta.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);
const rideSlice = createSlice({
  name: "rides",
  initialState,
  extraReducers: (builder) => {
    // TODO: fetch rides
    builder.addCase(fetchRides.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchRides.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.rides = action.payload;
    });

    builder.addCase(fetchRides.rejected, (state, action) => {
      state.fetchLoading = false;
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    builder.addCase(fetchRidesContinuously.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.rides = action.payload;
    });
  },
});

export default rideSlice.reducer;
